import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';
import { DrugService } from 'src/app/services/drug.service';

@Component({
  selector: 'app-drug-search',
  templateUrl: './drug-search.component.html',
  styleUrls: ['./drug-search.component.scss']
})
export class DrugSearchComponent implements OnInit {

  drugSearchControl = new UntypedFormControl();
  drugs: CNDrug[];
  @Output() selected: EventEmitter<[CNDrug, CNDrugPackage]> = new EventEmitter();

  constructor(private drug: DrugService) { }

  ngOnInit(): void {
    this.drugSearchControl.valueChanges.subscribe(value => {
      this.drug.search(value).subscribe(drugs => {
        this.drugs = drugs;
      });
    });
  }

  select(drugpackage: [CNDrug, CNDrugPackage]) {
    this.selected.emit(drugpackage);
  }
}
